// extracted by mini-css-extract-plugin
module.exports = {"container":"propertyGallerySecondary_container__3sx6E","video":"propertyGallerySecondary_video__2Ud8m","secondaryPhoto":"propertyGallerySecondary_secondaryPhoto__2Ual2"};
    if(module.hot) {
      // 1790670308240
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  